import React, { useCallback } from 'react';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import { logoutRoute } from 'App/common/routeLookup';
import FormButtonGroup from 'App/components/styles/FormButtonGroup';
import updateUser from '../utils/updateUser';
import SubmitButton from 'Shared/form/SubmitButton';

const propTypes = {
    onHide: PropTypes.func.isRequired,
    show: PropTypes.bool,
};

const defaultProps = {
    show: false,
};

function CompanyAdminEditModal({ onHide, show }) {
    const navigate = useNavigate();
    const { values, setSubmitting } = useFormikContext();

    const handleOnHide = () => {
        setSubmitting(false);
        onHide();
    };

    const goToUserManagerPage = useCallback(() => {
        navigate(logoutRoute);
    }, [navigate]);

    const handleOnConfirm = () => {
        setSubmitting(true);
        return updateUser(values).then(goToUserManagerPage);
    };

    return (
        <Modal onHide={onHide} backdrop="static" show={show}>
            <Modal.Header>Edit Your Account</Modal.Header>
            <Modal.Body>
                <p>Are you sure you want to edit your own access? This action will log you out of TherigySTM.</p>
                <p>
                    <strong>You may not be able to undo these changes.</strong>
                </p>
            </Modal.Body>
            <Modal.Footer>
                <FormButtonGroup>
                    <Button variant="outline-secondary" onClick={handleOnHide}>
                        Cancel
                    </Button>
                    <SubmitButton
                        onClick={() => {
                            return handleOnConfirm();
                        }}
                    >
                        Save & Logout
                    </SubmitButton>
                </FormButtonGroup>
            </Modal.Footer>
        </Modal>
    );
}

CompanyAdminEditModal.propTypes = propTypes;
CompanyAdminEditModal.defaultProps = defaultProps;

export default CompanyAdminEditModal;
